import { clip } from './clip';
import { vod } from './vod';

export const v1 = {
  clip,
  vod,
};
